import reactDom from "react-dom";
import Swal from "sweetalert2";
import LoginModal from "../base/features/blocks/LoginModal";
// import { updateMode } from "../settings/config";

function showError(text, width = 200) {
  Swal.fire({
    text: text,
    showConfirmButton: false,
    toast: true,
    customClass: {
      htmlContainer: "text-center m-0 w-auto",
    },
    width: width,
    timer: 3500,
    timerProgressBar: true,
  });
}

function handleHttpError401(error, productId) {
  localStorage.removeItem(`${window.location.hostname}_token`);
  if (window.location.pathname !== "/login") {
    localStorage.setItem("loginModal", true);
    reactDom.render(
      <LoginModal loginModal={true} productId={productId} />,
      document.getElementById("loginModal")
    );
  }
}

function handleHttpError403(error) {
  showError("شما اجازه دسترسی به این صفحه را ندارید", 300);
}

function handleHttpError404(error) {
  const netErr = Swal.mixin({
    customClass: {
      confirmButton: "btn rounded28 px-4 py-2 fw-bold bg-color-main text-white",
      container: "px-4",
      popup: "rounded14",
    },
    buttonsStyling: false,
  });
  netErr
    .fire({
      confirmButtonText: "صفحه اصلی",
      imageUrl: require(`../base/assets/images/404.svg`).default,
      imageWidth: 200,
    })
    .then(() => {
      window.location.href = "/";
    });
}

function handleHttpError500(error) {
  showError(
    "خطای سرور. خطا برای تیم فنی ارسال شد. در صورت نیاز با پشتیبانی تماس حاصل نمائید",
    300
  );
}

function handleHttpError502(error) {
  showError("در حال بروز رسانی هستیم، لطفا مدتی صبر و مجدد تلاش کنید", 220);
}

function handleHttpErrorDefault(error) {
  showError("متاسفانه درخواست شما با خطا مواجه شده است");
}

function handleNetworkError() {
  showError("اینترنت شما وصل نیست");
}

let handleError = (err, productId) => {
  if (err.message.includes("Network Error")) {
    handleNetworkError();
    return;
  }
  switch (err.response && err.response.status && err.response.status) {
    // 4xx errors
    case 401:
      handleHttpError401(err, productId);
      break;
    case 403:
      handleHttpError403(err);
      break;
    case 404:
      handleHttpError404(err);
      break;

    // 5xx errors
    case 500:
      handleHttpError500(err);
      break;
    case 502:
      handleHttpError502(err);
      break;
    default:
      handleHttpErrorDefault(err);
  }
};

export { handleError };
